import { CloseIcon, IconButton, MenuIcon } from "@povio/ui";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

import { UserAvatarNavSection } from "@/components/shared/layout/navbar/UserAvatarNavSection";
import { NavigationLinks } from "@/components/shared/layout/sidebar/Sidebar";
import { RouteConfig } from "@/config/route.config";
import { TourSelectors } from "@/config/tour.config";
import { useNavLinks } from "@/hooks/useNavLinks";

export const HamburgerMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const links = useNavLinks();
  const router = useRouter();

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isOpen]);

  return (
    <div id={TourSelectors.HamburgerMenu}>
      {!isOpen && (
        <IconButton
          label="Open menu"
          disableTooltip
          icon={MenuIcon}
          onPress={() => setIsOpen(true)}
          variant="text"
          color="secondary"
          size="xs"
          className="h-9 w-9! text-interactive-text-secondary-idle"
        />
      )}
      {isOpen && (
        <IconButton
          label="Close menu"
          disableTooltip
          icon={CloseIcon}
          onPress={() => setIsOpen(false)}
          variant="text"
          color="secondary"
          size="xs"
          className="h-6 w-6 text-interactive-text-secondary-idle"
        />
      )}
      {isOpen && (
        <div className="absolute top-18 right-0 bottom-0 left-0 flex h-[calc(100dvh-72px)] flex-col items-start justify-between bg-elevation-fill-default-0">
          <div className="flex h-auto w-full flex-1 flex-col items-start justify-start overflow-y-auto">
            <NavigationLinks
              links={links}
              onLinkClick={() => setIsOpen(false)}
              isMobile
            />
          </div>
          <div
            className="w-full border-elevation-outline-default-1 border-t p-6"
            onClick={() => {
              setIsOpen(false);
              router.push(RouteConfig.Settings);
            }}
          >
            <UserAvatarNavSection />
          </div>
        </div>
      )}
    </div>
  );
};
